import { catchAxiosError } from 'utilities/axios';
import axiosInstance from 'api-services/api-client';

export const getChatResponse = async (payload) => {
  return catchAxiosError(
    axiosInstance
      .post('/admin/chatbot-response', payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};
